import React, { useContext } from 'react';
import styled from 'styled-components';
import AlertModal from '../../components/modal/AlertModal';
import { useNavigate } from 'react-router-dom';
import { TimerComponent, sendInterval } from '../../components/Timer';
import LoginController from '../../controller/LoginController';

interface LoginFindMainProps {
  setFindIdSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  setFindPasswordSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
  typeForgot: string;
  moveLoginPage: () => void;
  setFindId: React.Dispatch<React.SetStateAction<string[]>>;
  setAuthenticationKey: React.Dispatch<React.SetStateAction<number>>;
  authenticationKey: number;
  setStoreId: React.Dispatch<React.SetStateAction<number>>;
}
let timer: any = null;
export const LoginAccountFind = ({
  setFindIdSuccess,
  setFindPasswordSuccess,
  setTitle,
  typeForgot,
  moveLoginPage,
  setFindId,
  setAuthenticationKey,
  authenticationKey,
  setStoreId,
}: LoginFindMainProps) => {
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = React.useState<number>(0);
  const [name, setName] = React.useState<string>('');
  const [phoneNumber, setPhoneNumber] = React.useState<string>('');
  const [accountId, setAccountId] = React.useState<string>('');
  const [nameErrorText, setNameErrorText] = React.useState<string>('');
  const [phoneErrorText, setPhoneErrorText] = React.useState<string>('');
  const [idErrorText, setIdErrorText] = React.useState<string>('');
  const [authenticationErrorText, setAuthenticationErrorText] = React.useState<string>('');
  const [authenticationNumber, setAuthenticationNumber] = React.useState<string>('');
  const [authenticationErrorModal, setAuthenticationErrorModal] = React.useState<boolean>(false);
  const [sendMessage, setSendMessage] = React.useState<boolean>(false);
  const [countError, setCountError] = React.useState<boolean>(false);
  const [countdown, setCountdown] = React.useState<number>(0);
  const [timerRunning, setTimerRunning] = React.useState<boolean>(false);

  const pattern = /[가-힣]*[ㄱ-ㅎㅏ-ㅣ]+[가-힣]*/;

  // inputonChange
  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    nameErrorText: string,
    phoneErrorText: string,
  ) => {
    const value = event.target.value;
    const regExp = /[0-9 \{\}\[\]\/?.,;:|\)*~`!^\-_+┼<>@\#$%&\'\"\\\(\=]/gi;
    const numericValue = value.replace(/\D/g, '');
    if (event.target.id === 'name') {
      setName(value);
      if (regExp.test(value)) {
        setNameErrorText(nameErrorText);
      } else {
        setNameErrorText('');
      }
    } else if (event.target.id === 'accountId') {
      setAccountId(value);
      if (accountId.length > 0) {
        setIdErrorText('');
      }
    } else if (event.target.id === 'phoneNumber') {
      setPhoneNumber(numericValue);
      if (numericValue.length > 11) {
        setPhoneErrorText('올바른 휴대폰 번호를 입력해주세요.');
      } else {
        setPhoneErrorText('');
      }
    } else if (event.target.id === 'authenticationNumber') {
      setAuthenticationNumber(numericValue);
    }
  };

  // 인증번호 발송
  const sendAuthenticationNumber = () => {
    if (menuTab[currentTab].tabStatus === 'id' && name === '') {
      setNameErrorText('대표자명을 입력해 주세요');
    }
    if (pattern.test(name)) {
      setNameErrorText('특수문자, 숫자가 없는 올바른 이름만 입력해주세요.');
    }
    if (menuTab[currentTab].tabStatus === 'password' && accountId === '') {
      setIdErrorText('아이디를 입력해 주세요');
    }
    if (phoneNumber === '' || phoneNumber.length < 10 || phoneNumber.length > 11) {
      setPhoneErrorText('올바른 휴대폰 번호를 입력해주세요.');
    } else {
      if (menuTab[currentTab].tabStatus === 'id') {
        findForgetIdAuth();
        setTimerRunning(true);
      } else if (menuTab[currentTab].tabStatus === 'password') {
        findForgetPwdAuth();
        setTimerRunning(true);
      }
    }
  };

  // 인증번호 재전송
  const reSendAuthenticationNumber = () => {
    if (menuTab[currentTab].tabStatus === 'id' && name === '') {
      setNameErrorText('대표자명을 입력해 주세요');
    }
    if (pattern.test(name)) {
      setNameErrorText('특수문자, 숫자가 없는 올바른 이름만 입력해주세요.');
    } else if (menuTab[currentTab].tabStatus === 'password' && accountId === '') {
      setIdErrorText('아이디를 입력해 주세요');
    } else if (phoneNumber === '' || phoneNumber.length < 10 || phoneNumber.length > 11) {
      setPhoneErrorText('올바른 휴대폰 번호를 입력해주세요.');
    } else {
      if (timer === null) {
        setAuthenticationErrorText('');
        setSendMessage(true);

        timer = sendInterval(180, setCountdown, () => {
          setAuthenticationErrorText('입력시간이 초과! 인증번호 재전송을 눌러주세요.');

          setTimerRunning(false);
          timer = null;
        });

        if (menuTab[currentTab].tabStatus === 'id') {
          findForgetIdAuth();
          setTimerRunning(true);
        } else if (menuTab[currentTab].tabStatus === 'password') {
          findForgetPwdAuth();
          setTimerRunning(true);
        }
      } else {
        setAuthenticationErrorText('인증번호가 이미 발송되었습니다.');
      }
    }
  };

  // 인증번호 확인
  const checkAuthenticationNumber = () => {
    const isValid = checkAuthenticationResult();
    if (isValid) {
      authNumVerify();
    } else {
      setAuthenticationErrorText('인증번호를 확인해주세요');
    }
  };
  const checkAuthenticationResult = () => {
    let isValid = true;

    if (menuTab[currentTab].tabStatus === 'id') {
      if (name === '') {
        setNameErrorText('대표자명을 입력해 주세요');
        isValid = false;
      } else if (pattern.test(name)) {
        setNameErrorText('특수문자, 숫자가 없는 올바른 이름만 입력해주세요.');
        isValid = false;
      }
    } else if (menuTab[currentTab].tabStatus === 'password') {
      if (accountId === '') {
        setIdErrorText('아이디를 입력해 주세요');
        isValid = false;
      }
    }

    if (phoneNumber === '' || phoneNumber.length < 10 || phoneNumber.length > 11) {
      setPhoneErrorText('올바른 휴대폰 번호를 입력해주세요.');
      isValid = false;
    }

    return isValid;
  };

  //모달닫기
  const handleCloseModal = () => {
    setAuthenticationErrorModal(false);
  };

  // Tab
  const menuTab = [
    { name: '아이디 찾기', tabStatus: 'id' },
    { name: '비밀번호 찾기', tabStatus: 'password' },
  ];
  const selectMenuHandler = (index: number) => {
    setCurrentTab(index);
    clearInterval(timer);
    setAuthenticationErrorText('');

    if (index === 0) {
      navigate('/loginIdForget');
    } else {
      navigate('/loginPasswordForget');
    }
    // 초기화
    setName('');
    setPhoneNumber('');
    setAccountId('');
    setNameErrorText('');
    setPhoneErrorText('');
    setIdErrorText('');
    setSendMessage(false);
    setCountdown(0);
    setCountError(false);
    setAuthenticationNumber('');
  };
  React.useEffect(() => {
    setFindId([]);
    if (typeForgot === 'id') {
      setCurrentTab(0);
    } else if (typeForgot === 'password') {
      setCurrentTab(1);
    }
  }, []);

  // api_아이디찾기
  const findForgetIdAuth = async () => {
    let oData: any = {
      user_name: name,
      phone_number: phoneNumber,
    };

    try {
      const oResp = await LoginController.findForgetIdAuth(oData);
      let oResponse = oResp?.data;

      if (oResponse.ok === true && oResponse !== undefined) {
        setSendMessage(true);
        clearInterval(timer);
        setTimerRunning(true);
        setAuthenticationKey(oResponse.data.key);
        timer = sendInterval(180, setCountdown, () => {
          setAuthenticationErrorText('입력시간이 초과! 인증번호 재전송을 눌러주세요.');
          timer = null;
        });
      } else {
        setNameErrorText('올바른 이름을 입력해 주세요.');
        setPhoneErrorText('올바른 휴대폰 번호를 입력해주세요.');
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  // api_비밀번호찾기
  const findForgetPwdAuth = async () => {
    let oData: any = {
      id: accountId,
      phone_number: phoneNumber,
    };

    try {
      const oResp = await LoginController.findForgetPwdAuth(oData);
      let oResponse = oResp?.data;

      if (oResponse.ok === true && oResponse !== undefined) {
        setSendMessage(true);
        clearInterval(timer);
        setTimerRunning(true);
        setAuthenticationKey(oResponse.data.key);
        setStoreId(oResponse.data.store_id);
        timer = sendInterval(180, setCountdown, () => {
          setAuthenticationErrorText('입력시간이 초과! 인증번호 재전송을 눌러주세요.');
          timer = null;
        });
      } else {
        setNameErrorText('올바른 아이디를 입력해 주세요.');
        setPhoneErrorText('올바른 휴대폰 번호를 입력해주세요.');
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  // api_아이디/비밀번호_카카오톡 인증번호
  const authNumVerify = async () => {
    let oData: any = {
      key: authenticationKey,
      auth_number: authenticationNumber,
    };
    try {
      const oResp = await LoginController.authNumVerify(oData);
      let oResponse = oResp.data;

      if (oResponse.ok === true && oResponse !== undefined && oResponse.data.is_matched === true) {
        if (menuTab[currentTab].tabStatus === 'id') {
          setTitle('아이디 찾기 결과');
          setFindIdSuccess(true);
          setFindId([...oResponse.data.ids]);
        } else if (menuTab[currentTab].tabStatus === 'password') {
          setTitle('비밀번호 변경');
          setFindPasswordSuccess(true);
          setFindId([accountId]);
          console.log('비밀번호 변경======>', oResponse);
        }
      } else if (oResponse.data.is_matched === false || oResponse.ok === false) {
        setAuthenticationErrorModal(true);
        setAuthenticationErrorText('인증번호를 확인해주세요');
      } else {
        setAuthenticationErrorModal(true);
        setAuthenticationErrorText('인증번호를 확인해주세요');
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  return (
    <Style>
      <div className="findWrap">
        <div className="findContent">
          <ul className="tab">
            {menuTab.map((el, index) => (
              <li
                className={index === currentTab ? 'tabmenuFocused' : 'tabmenu'}
                onClick={() => selectMenuHandler(index)}
                key={index}>
                {el.name}
              </li>
            ))}
          </ul>
          {menuTab[currentTab].tabStatus === 'id' && (
            <div>
              <div className="loginForm">
                <label htmlFor="name">대표자명</label>
                <input
                  type="text"
                  id="name"
                  value={name}
                  onChange={(e) =>
                    handleInputChange(e, '특수문자나 숫자가 없는 올바른 이름만 입력해주세요.', '')
                  }
                  placeholder="대표자명을 입력해 주세요"
                  style={{ border: nameErrorText !== '' ? '1px solid #FDA29B' : '' }}
                />
              </div>
              <p className="errorMessage">{nameErrorText}</p>
            </div>
          )}
          {menuTab[currentTab].tabStatus === 'password' && (
            <div>
              <div className="loginForm">
                <label htmlFor="accountId">아이디</label>
                <input
                  type="text"
                  id="accountId"
                  value={accountId}
                  onChange={(e) =>
                    handleInputChange(e, '특수문자나 숫자가 없는 올바른 이름만 입력해주세요.', '')
                  }
                  placeholder="아이디를 입력해 주세요"
                  style={{ border: idErrorText !== '' ? '1px solid #FDA29B' : '' }}
                />
              </div>
              <p className="errorMessage">{idErrorText}</p>
            </div>
          )}

          <div className="loginForm">
            <label htmlFor="phoneNumber">휴대폰 번호</label>
            <input
              type="text"
              id="phoneNumber"
              value={phoneNumber}
              onChange={(e) => handleInputChange(e, '올바른 휴대폰 번호를 입력해주세요.', '')}
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder="- 없이 휴대폰 번호를 입력해주세요"
              style={{ border: phoneErrorText !== '' ? '1px solid #FDA29B' : '' }}
            />
          </div>
          <p className="errorMessage">{phoneErrorText}</p>
          {sendMessage && (
            <div>
              <div className="loginForm">
                <div className="authenticationForm">
                  <input
                    type="text"
                    id="authenticationNumber"
                    value={authenticationNumber}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    onChange={(event) => handleInputChange(event, '', '')}
                    placeholder="발송된 인증번호를 입력해주세요"
                    style={{
                      width: '100%',
                      border: authenticationErrorText !== '' ? '1px solid red' : '',
                    }}
                  />
                  <div className="timer">
                    <TimerComponent countdown={countdown} />
                  </div>
                </div>
              </div>
              <p className="errorMessage">{authenticationErrorText}</p>
              <p className="noticeMessage">
                인증번호 전송은 통신사에 따라 차이가 있을 수 있습니다.
                <br />
                번호가 도착하지 않으면
                <button onClick={reSendAuthenticationNumber}>인증번호 재전송</button> 을 눌러주세요.
              </p>
            </div>
          )}
          {sendMessage === false ? (
            <button className="authenticationNumber" onClick={sendAuthenticationNumber}>
              <p>인증번호 받기</p>
            </button>
          ) : (
            <button className="checkAuthenticationNumber" onClick={checkAuthenticationNumber}>
              <p>인증번호 확인</p>
            </button>
          )}
        </div>
      </div>
      <button onClick={moveLoginPage} className="backPageButton">
        <p>로그인 페이지로 돌아가기</p>
      </button>
      <AlertModal
        isOpen={authenticationErrorModal}
        onCancel={handleCloseModal}
        title={`인증번호 확인`}
        content={`아직 인증이 완료되지 않았습니다.\n입력정보들을 다시 확인하신 후에도\n인증번호가 오지 않으면 ‘인증번호 재전송’을 눌러주세요.`}
        onCloseText={'확인'}
      />
    </Style>
  );
};

export const Style = styled.div`
  /* tab */
  ul {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 32px;
    padding: 4px;
    background: #f9fafb;
    border: 1px solid #f2f4f7;
    border-radius: 8px;
  }
  li {
    flex: 0 0 50%;
    padding: 8px;
    border-radius: 6px;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    color: #72727e;
    cursor: pointer;
  }
  .tabmenuFocused {
    color: #3b4044;
    background: #fff;
  }

  /* inputStyle */
  .loginForm {
    display: flex;
    flex-direction: column;
    margin-bottom: 0;

    label {
      margin-top: 12px;
      margin-bottom: 6px;
      font-size: 14px;
      font-weight: 500;
      color: #4f5459;
    }
    input {
      padding: 10px 14px;
      border: 1px solid #d0d5dd;
      border-radius: 8px;
      outline: none;
    }
  }

  /* errorMessage */
  .noticeMessage,
  .errorMessage {
    width: 100%;
    margin: 2px 0 6px 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #4f5459;

    button {
      font-weight: 600;
      text-decoration: underline;
      text-underline-offset: 4px;
      background: none;
      outline: none;
      border: none;
      color: #4f5459;
      font-size: 14px;
      font-weight: 600;
    }
  }
  .errorMessage {
    color: #f04438;
    font-size: 14px;
    font-weight: 500;
  }
  .errorMessage:nth-child(6) {
    margin-bottom: 12px;
  }

  /* 인증번호받기 버튼 */
  .authenticationNumber,
  .checkAuthenticationNumber {
    width: 100%;
    padding: 12px 0;
    margin: 12px 0 24px 0;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #72727e;
    outline: none;

    p {
      font-size: 18px;
      font-weight: 600;
      color: #26282c;
    }
  }
  .checkAuthenticationNumber {
    background: #26282c;
    border: none;

    p {
      color: #ffffff;
    }
  }

  /* 인증번호 */
  .authenticationForm {
    position: relative;

    .timer {
      position: absolute;
      top: 35%;
      right: 12px;

      p {
        margin: 0;
        font-size: 12px;
        font-weight: 500;
        color: #f04438;
      }
    }
  }
`;
